import { Provider } from 'react-redux';
import { HashRouter, Route, Routes } from 'react-router';

import { main } from './configuration';
import { store } from './configuration/setup/store';

import { config } from './config';
import { ErrorBoundary } from './features/app/ErrorBoundary';
import DefaultRedirect from './features/app/DefaultRoute';
import { createRoot } from 'react-dom/client';
import { handleSilentSigninRedirectInIframe } from './configuration/login/redirect';
import App from './features/app/App';
import { GoogleTagListener } from './GtmTagListener';

const renderApplication = () => {
    const container = document.getElementById('root');
    // biome-ignore lint/style/noNonNullAssertion: suppress out of convenience during migration to biome
    const root = createRoot(container!);

    root.render(
        <ErrorBoundary>
            <Provider store={store}>
                <HashRouter>
                    <Routes>
                        <Route path='*' element={<DefaultRedirect />} />
                        <Route path='/tags' element={<App />} />
                        <Route path='/tags/:id' element={<App />} />
                    </Routes>
                    <GoogleTagListener />
                </HashRouter>
            </Provider>
        </ErrorBoundary>
    );
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;

if ((isDev && config.enableMockServer) || isProdPreview) {
    import('../mocks/browser').then(({ startWorker }) => startWorker()).then(() => main(renderApplication));
}

const isRedirect = window.location.href.startsWith(config.login.redirectUri as string);
const runsInIframe = 'parent' in window && window.parent !== window;

if (isRedirect && runsInIframe) {
    void handleSilentSigninRedirectInIframe();
} else if (isProd && !isProdPreview) {
    main(renderApplication);
}
